(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zaverales-product-grid"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sectionId = '{{ section.id }}';
    const container = document.querySelector(`.zaver-container[data-section-id="${sectionId}"]`);
    if (!container) return;

    // ── Elements ──
    const grid = document.getElementById(`productGrid-${sectionId}`);
    const categoryNav = document.getElementById(`categoryNav-${sectionId}`);
    const cards = grid ? Array.from(grid.querySelectorAll('.product-card')) : [];

    // ── Toast (simple) ──
    function showToast(message) {
      let toast = document.querySelector('.zaver-toast');
      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'zaver-toast';
        toast.style.cssText = `
          position: fixed; bottom: 2rem; left: 50%; transform: translateX(-50%) translateY(80px);
          background: rgba(20,18,19,0.92); backdrop-filter: blur(14px);
          border: 1px solid rgba(212,165,116,0.15); padding: 0.7rem 2rem;
          border-radius: 60px; font-size: 0.75rem; letter-spacing: 1.5px;
          color: #d4a574; box-shadow: 0 12px 40px rgba(0,0,0,0.6);
          opacity: 0; transition: opacity 0.4s ease, transform 0.5s cubic-bezier(0.34,1.56,0.64,1);
          z-index: 9999; pointer-events: none; white-space: nowrap;
          font-family: "Inter", sans-serif;
        `;
        document.body.appendChild(toast);
      }
      toast.innerHTML = `<i class="fas fa-check-circle" style="margin-right:0.6rem;"></i> ${message}`;
      toast.style.opacity = '1';
      toast.style.transform = 'translateX(-50%) translateY(0)';
      clearTimeout(toast._timer);
      toast._timer = setTimeout(() => {
        toast.style.opacity = '0';
        toast.style.transform = 'translateX(-50%) translateY(80px)';
      }, 2200);
    }

    // ── Category filter ──
    if (categoryNav) {
      const links = categoryNav.querySelectorAll('.category-link');
      links.forEach(link => {
        link.addEventListener('click', function(e) {
          e.preventDefault();
          links.forEach(l => l.classList.remove('active'));
          this.classList.add('active');

          const tag = this.dataset.tag;
          if (tag === 'all') {
            cards.forEach(card => card.classList.remove('filter-hidden'));
          } else {
            cards.forEach(card => {
              const tags = card.dataset.tags || '';
              const match = tags.includes(tag);
              card.classList.toggle('filter-hidden', !match);
            });
          }
        });
      });
    }

    // ── Wishlist toggle ──
    const wishlistBtns = container.querySelectorAll('.btn-wishlist');
    wishlistBtns.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        const icon = this.querySelector('i');
        if (icon.classList.contains('far')) {
          icon.classList.remove('far');
          icon.classList.add('fas');
          this.style.color = '#d4a574';
          showToast('Added to wishlist ❤️');
        } else {
          icon.classList.remove('fas');
          icon.classList.add('far');
          this.style.color = '';
          showToast('Removed from wishlist');
        }
      });
    });

    // ── Add to Cart (Horizon compatible) ──
    const addBtns = container.querySelectorAll('.btn-add');
    addBtns.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        const variantId = this.dataset.variantId;
        const productTitle = this.dataset.productTitle || 'Item';
        if (!variantId) {
          showToast('Variant not available');
          return;
        }

        // Visual feedback
        const originalHtml = this.innerHTML;
        this.classList.add('added');
        this.innerHTML = '<i class="fas fa-check"></i> Added';

        // --- Try Horizon's native cart method first ---
        const addToCart = (id, qty) => {
          return new Promise((resolve, reject) => {
            // If theme has a global 'theme' object with cart.addItem, use it
            if (window.theme && typeof theme.cart === 'object' && typeof theme.cart.addItem === 'function') {
              theme.cart.addItem(id, qty, (err, data) => {
                if (err) reject(err);
                else resolve(data);
              });
              return;
            }

            // Fallback to standard Shopify AJAX
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
            })
            .then(response => response.json())
            .then(data => resolve(data))
            .catch(err => reject(err));
          });
        };

        // Execute add-to-cart
        addToCart(variantId, 1)
          .then(data => {
            showToast(`${productTitle} added to bag`);
            // Dispatch event for Horizon (and others) to refresh cart
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
            // Also trigger any global cart update events
            if (window.theme && typeof theme.cart === 'object' && typeof theme.cart.update === 'function') {
              theme.cart.update();
            }
          })
          .catch(err => {
            console.error('Add to cart error:', err);
            showToast('Error adding to cart');
          })
          .finally(() => {
            setTimeout(() => {
              this.classList.remove('added');
              this.innerHTML = originalHtml;
            }, 2200);
          });
      });
    });

    // ── Load Font Awesome if not present ──
    if (!document.querySelector('#zaver-fa-cdn')) {
      const link = document.createElement('link');
      link.id = 'zaver-fa-cdn';
      link.rel = 'stylesheet';
      link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css';
      document.head.appendChild(link);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
